import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AccessDeniedPage } from './access-denied.page';
import { ContactAdminModalModule } from './contact-admin-modal/contact-admin-modal.module';

const routes: Routes = [
  {
    path: '',
    component: AccessDeniedPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule.forChild(routes),
    ContactAdminModalModule
  ],
  declarations: [AccessDeniedPage]
})
export class AccessDeniedPageModule {} 